import { resolveCurrencySymbol } from './resolve-currency-symbol.js';
/**
 * Formats a minor-units amount as a localised currency string.
 *
 * Uses en-ZA to resolve the currency symbol (e.g. "R" for ZAR), then
 * en-GB for the number format (comma thousands separator, period decimal).
 *
 * Returns '-' when minorUnits is null. Currency defaults to 'ZAR' when
 * null or undefined (the platform's default currency).
 *
 * Example: formatCurrency(150000, 'ZAR') => 'R1,500.00'
 *          formatCurrency(null, 'ZAR')   => '-'
 *          formatCurrency(150000)        => 'R1,500.00'
 *          formatCurrency(150000, null)  => 'R1,500.00'
 */
export function formatCurrency(minorUnits, currency) {
    if (minorUnits === null)
        return '-';
    const resolvedCurrency = currency ?? 'ZAR';
    const amount = minorUnits / 100;
    const symbol = resolveCurrencySymbol(resolvedCurrency);
    const number = new Intl.NumberFormat('en-GB', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(Math.abs(amount));
    const sign = amount < 0 ? '-' : '';
    return `${sign}${symbol}${number}`;
}
